//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "infor-public",
  data(){
    return{
      value:'',
      wrapperHeight:0,
      allLoaded:false,
      articleList:[],
      page:0,
      searchData:{'readStatus':'1'},
      sort:'DESC'
    }
  },
  methods:{
    clear(){
      delete  this.searchData['title'];
      this.getArticleList()
    },
    searchList(searchData){
      this.searchData= Object.assign(searchData,this.searchData);
      this.getArticleList()
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight =
        document.documentElement.clientHeight -
        this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    onItemClick(index){
      if(index){
        this.searchData['category.id'] = index;
      }else{
        delete this.searchData['category.id'];
      }
      this.getArticleList();
    },
    loadTop(){
      this.page = 0;
      this.$search('/api/article', {sort: 'createdDate,' + this.sort, page: this.page, size: 10},this.searchData).then(list => {
        this.articleList = list;
        this.$refs.loadmore.onTopLoaded();
      }).catch((error) => {
        this.$refs.loadmore.onTopLoaded();
      });
    },
    loadBottom(){
      this.page++;
      this.$search('/api/article', {sort: 'createdDate,' + this.sort, page: this.page, size: 10},this.searchData).then(list => {
        this.articleList = this.articleList.concat(list);
        this.$refs.loadmore.onBottomLoaded();
      }).catch((error) => {
        this.$refs.loadmore.onBottomLoaded();
      });
    },
    getArticleList(){
      this.$loadingShow();
      this.$search('/api/article', {sort: 'createdDate,' + this.sort, page: 0, size: 10},this.searchData).then(list => {
        this.articleList = list;
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    sortChange(){
      this.page = 0;
      if(this.sort === 'ASC'){
        this.sort = 'DESC'
      }else{
        this.sort = 'ASC'
      }
      this.getArticleList();
    },
    goArticleDetail(id){
      this.$router.push('/article/' + id+'?comment=1');
    },
  },
  mounted(){
    this.init();
    this.getArticleList();
  }
}



// WEBPACK FOOTER //
// ./src/page/home/infor-public.vue